import { createSlice } from "@reduxjs/toolkit";
import { getDevices, reportVinError } from "./_deviceAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0
};

export const devicesList = createSlice({
  name: "devicesList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDevices.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getDevices.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getDevices.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(reportVinError.fulfilled, (state, { payload }) => {
        state.vinErrorReportSuccess = true;
        state.vinErrorReportMessage = payload.responseMessage || 'VIN error report submitted successfully';
      })
      .addCase(reportVinError.rejected, (state, { payload }) => {
        state.vinErrorReportSuccess = false;
        state.vinErrorReportMessage = payload || 'Failed to submit report';
      });
  },
});
